import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, mergeMap, of, tap } from 'rxjs';
import { map } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { BreadcrumbService } from '@app/resources/services/breadcrumb.service';
import { NonMembersApiService } from '@app/areas/non-members/services';
import { NonConsumerActions, RouterActions } from '@app/resources/ngrx/actions';
import { NonMemberModuleActions } from '@app/areas/non-members/store/non-member-module.actions';

@Injectable()
export class NonMemberModuleEffects {
  private readonly actions$ = inject(Actions);
  private readonly store = inject(Store);
  private readonly nonMembersApiService = inject(NonMembersApiService);
  private readonly breadcrumbService = inject(BreadcrumbService);

  loadNonMembers = createEffect(
    () =>
      this.actions$.pipe(
        ofType(NonConsumerActions.loadNonConsumers),
        exhaustMap(() =>
          this.nonMembersApiService.getNonMembers().pipe(
            map((consumers) => {
              return NonConsumerActions.loadNonConsumersSuccess({ payload: { consumers } });
            }),
            catchError((error) => {
              return of(
                NonConsumerActions.loadNonConsumersError({ payload: { error: error?.message || 'Unknown error' } })
              );
            })
          )
        )
      ),
    { dispatch: true }
  );

  navigateToNonMemberForm = createEffect(
    () =>
      this.actions$.pipe(
        ofType(NonMemberModuleActions.navigateNonMember),
        tap(({ payload }) => {
          this.store.dispatch(
            RouterActions.navigateByUrlWithLocation({
              payload: {
                path: `non-members/${payload.consumerId}`,
                extras: { queryParams: this.breadcrumbService.buildTrailQueryParams() },
              },
            })
          );
        })
      ),
    {
      dispatch: false,
    }
  );
}
